import React, { Component } from "react";
import { graphql, compose } from "react-apollo";

// Mutation
import editSurvey from "../../../../mutations/editSurvey";

// Icons
import TimeIco from "react-icons/lib/md/timer";
import EditIco from "react-icons/lib/md/edit";

class EditBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: false
    };
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
  }
  componentDidMount() {
    const {
      id,
      published,
      titulo,
      tiempo,
      descripcion,
      fecha
    } = this.props.survey;
    this.setState({ id, published, titulo, tiempo, descripcion, fecha });
  }
  handleOnClick(e) {
    const { id, published, titulo, tiempo, descripcion, fecha } = this.state;
    this.props
      .editSurvey({
        variables: { id, published, titulo, tiempo, descripcion, fecha }
      })
      .then(this.props.parentRefetchCallback())
      .then(this.setState({ edit: false }));
  }
  handleOnChange(e) {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  render() {
    const { titulo, descripcion, tiempo, fecha } = this.props.survey;
    if (this.state.edit) {
      return (
        <div className="card mb-4">
          <div className="card-body">
            <div className="mb-2">
              <div className="form-group switch">
                <input
                  type="checkbox"
                  className="switch"
                  name="published"
                  id="switch-id"
                  checked={this.state.published}
                  onChange={this.handleOnChange}
                />
                <label
                  htmlFor="switch-id"
                  className={
                    this.state.published ? "text-success" : "text-muted"
                  }
                >
                  Publicado
                </label>
              </div>
              <div className="form-group">
                <label htmlFor="titulo">Título</label>
                <input
                  type="text"
                  name="titulo"
                  onChange={this.handleOnChange}
                  value={this.state.titulo}
                  className="form-control"
                  id="titulo"
                />
              </div>
              <div className="form-group">
                <label>Fecha control de publicación</label>
                <input
                  type="date"
                  name="fecha"
                  onChange={this.handleOnChange}
                  value={this.state.fecha}
                  className="form-control"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="tiempo">Tiempo</label>
                <input
                  type="text"
                  name="tiempo"
                  onChange={this.handleOnChange}
                  value={this.state.tiempo}
                  className="form-control"
                  id="tiempo"
                />
              </div>
              <div className="form-group">
                <label htmlFor="descripcion">Descripción</label>
                <textarea
                  name="descripcion"
                  onChange={this.handleOnChange}
                  value={this.state.descripcion}
                  className="form-control"
                  id="descripcion"
                />
              </div>
            </div>
            <button
              type="submit"
              onClick={this.handleOnClick}
              className="btn btn-primary"
            >
              Guardar
            </button>
            <hr />
            <div className="mt-2">
              <a href="#" onClick={() => this.setState({ edit: false })}>
                <EditIco /> Ocultar edición
              </a>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="card mb-4">
        <div className="card-body">
          <div style={{ display: "flex" }}>
            <h1 className="mr-2">{titulo}</h1>
            <span
              style={{ alignSelf: "center" }}
              className={
                this.props.survey.published
                  ? "badge badge-success mb-2"
                  : "badge badge-secondary mb-2"
              }
            >
              {this.props.survey.published ? "Publicado" : "No Publicado"}
            </span>
          </div>
          <div className="mb-2">
            <strong>Fecha control de publicación: {fecha}</strong>
          </div>
          <div className="mb-2">
            <TimeIco /> Tiempo: {tiempo}
          </div>
          <div className="excerpt">{descripcion}</div>
          <div className="mt-2">
            <a href="#" onClick={() => this.setState({ edit: true })}>
              <EditIco /> Editar
            </a>
          </div>
        </div>
      </div>
    );
  }
}

const EditBodyMutations = compose(
  graphql(editSurvey, {
    name: "editSurvey"
  })
);

export default EditBodyMutations(EditBody);



// WEBPACK FOOTER //
// ./src/components/Survey/admin/EditBody/index.js